import { css } from '@linaria/core';

import { clsx, pxToRem } from '@creditornot/cb-utils';

export * from './typographyClassNameNew';

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const headingBase: string = css`
  @layer cb {
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-variant-ligatures: common-ligatures;
    font-style: normal;
    font-stretch: normal;
    text-transform: none;
    font-family: var(--cb-font-family-brand);
  }
`;

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const bodyBase: string = css`
  @layer cb {
    font-feature-settings: 'kern';
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-family: var(--cb-font-family-sans);
    font-style: normal;
    font-stretch: normal;

    b,
    strong {
      font-weight: 600;
    }
  }
`;

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.display`.
 */
export const Heading1: string = clsx(
  headingBase,
  css`
    @layer cb {
      font-size: ${pxToRem(48)};
      line-height: ${pxToRem(52)};
      font-weight: 600;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.display`.
 */
export const Heading2: string = clsx(
  headingBase,
  css`
    @layer cb {
      font-size: ${pxToRem(40)};
      line-height: ${pxToRem(44)};
      font-weight: 600;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.largeTitle`.
 */
export const Heading3: string = clsx(
  headingBase,
  css`
    @layer cb {
      font-size: ${pxToRem(32)};
      line-height: ${pxToRem(36)};
      font-weight: 600;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.title`.
 */
export const Heading4: string = clsx(
  headingBase,
  css`
    @layer cb {
      font-size: ${pxToRem(28)};
      line-height: ${pxToRem(32)};
      font-weight: 600;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.title`.
 */
export const Heading5: string = clsx(
  headingBase,
  css`
    @layer cb {
      font-size: ${pxToRem(24)};
      line-height: ${pxToRem(28)};
      font-weight: 600;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.headline`.
 */
export const Heading6: string = clsx(
  headingBase,
  css`
    @layer cb {
      font-size: ${pxToRem(20)};
      line-height: ${pxToRem(24)};
      font-weight: 600;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.subheadline`.
 */
export const Title1: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(16)};
      line-height: ${pxToRem(20)};
      font-weight: 700;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.captionLabel`.
 */
export const Title2: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(14)};
      line-height: ${pxToRem(20)};
      font-weight: 700;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const Subtitle: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(12)};
      line-height: ${pxToRem(16)};
      font-weight: 700;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.body`.
 */
export const Body1: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(18)};
      line-height: ${pxToRem(24)};
      font-weight: 400;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.bodyLabel`.
 */
export const Body1SemiBold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(18)};
      line-height: ${pxToRem(24)};
      font-weight: 500;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.bodyLabel`.
 */
export const Body1Bold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(18)};
      line-height: ${pxToRem(24)};
      font-weight: 700;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.body`.
 */
export const Body2: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(16)};
      line-height: ${pxToRem(20)};
      font-weight: 400;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.bodyLabel`.
 */
export const Body2SemiBold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(16)};
      line-height: ${pxToRem(20)};
      font-weight: 500;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.bodyLabel`.
 */
export const Body2Bold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(16)};
      line-height: ${pxToRem(20)};
      font-weight: 700;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.caption`.
 */
export const Body3: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(14)};
      line-height: ${pxToRem(20)};
      font-weight: 400;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.captionLabel`.
 */
export const Body3SemiBold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(14)};
      line-height: ${pxToRem(20)};
      font-weight: 500;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.captionLabel`.
 */
export const Body3Bold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(14)};
      line-height: ${pxToRem(20)};
      font-weight: 700;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.footnote`.
 */
export const Small: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(12)};
      line-height: ${pxToRem(16)};
      font-weight: 400;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.footnoteLabel`.
 */
export const SmallSemiBold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(12)};
      line-height: ${pxToRem(16)};
      font-weight: 500;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.footnoteLabel`.
 */
export const SmallBold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(12)};
      line-height: ${pxToRem(16)};
      font-weight: 700;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.footnote`.
 */
export const Tiny: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(10)};
      line-height: ${pxToRem(12)};
      font-weight: 400;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.footnoteLabel`.
 */
export const TinySemiBold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(10)};
      line-height: ${pxToRem(12)};
      font-weight: 500;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 *
 * Possible replacement: `typographyClassName.footnoteLabel`.
 */
export const TinyBold: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(10)};
      line-height: ${pxToRem(12)};
      font-weight: 700;

      b,
      strong {
        font-weight: 700;
      }
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const Overline1: string = clsx(
  bodyBase,
  css`
    @layer cb {
      text-transform: uppercase;
      font-size: ${pxToRem(16)};
      line-height: ${pxToRem(20)};
      font-weight: 500;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const Overline2: string = clsx(
  bodyBase,
  css`
    @layer cb {
      text-transform: uppercase;
      font-size: ${pxToRem(14)};
      line-height: ${pxToRem(20)};
      font-weight: 500;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const Overline3: string = clsx(
  bodyBase,
  css`
    @layer cb {
      text-transform: uppercase;
      font-size: ${pxToRem(12)};
      line-height: ${pxToRem(16)};
      font-weight: 500;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const Overline4: string = clsx(
  bodyBase,
  css`
    @layer cb {
      text-transform: uppercase;
      font-size: ${pxToRem(10)};
      line-height: ${pxToRem(12)};
      font-weight: 500;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const Quote1: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(16)};
      line-height: ${pxToRem(20)};
      font-weight: 500;
      font-style: italic;
    }
  `,
);

/**
 * @deprecated This style is deprecated.
 * If you still need to access the old text styles, please use `legacyTypographyClassName`.
 */
export const Quote2: string = clsx(
  bodyBase,
  css`
    @layer cb {
      font-size: ${pxToRem(14)};
      line-height: ${pxToRem(20)};
      font-weight: 500;
      font-style: italic;
    }
  `,
);
